import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetGiftCardTransactionReport = (params: any) =>
    request({
        url: ApiURL.Query.GetGiftCardTransactionReport,
        method: RequestType.GET,
        params: params,
    });

const GiftCardQuery = {
    GetGiftCardTransactionReport,
};

export default GiftCardQuery;
